<div class="institution_data" [formGroup]="instituicaoForm">
  <p i18n><strong>{{ 'Dados da instituição' | translate}}</strong></p>
  <div class="institution_data__itens">
    <div class="flex gap-1">
      <div class="institution_data__nome">
        <label><strong i18n>{{ 'Nome' | translate}}:</strong></label>
        <ng-container *ngIf="isSmartCase; else normalInput">
          <input type="text" formControlName="nomeInstituicao" (keypress)="validarEntrada.emit($event)" class="name_size" appSmartCase [ngClass]="{'uppercase': !instituicaoForm.get('nomeInstituicao')?.dirty, 'lowercase': instituicaoForm.get('nomeInstituicao')?.dirty}" appClearOnAltD />
        </ng-container>
        <ng-template #normalInput>
          <input type="text" formControlName="nomeInstituicao" (keypress)="validarEntrada.emit($event)" class="name_size"  appClearOnAltD appLowercaseOnChange />
        </ng-template>
      </div>

      <div class="institution_data__nome">
        <label><strong i18n>{{ 'E-mail' | translate}}:</strong></label>
        <ng-container *ngIf="isSmartCase; else instituicaoEmailInput">
          <input type="text" formControlName="email" (keypress)="validarEntrada.emit($event)" class="email_size" [ngClass]="{'uppercase': !instituicaoForm.get('email')?.dirty, 'lowercase': instituicaoForm.get('email')?.dirty}" appClearOnAltD appSmartCase />
        </ng-container>
        <ng-template #instituicaoEmailInput>
          <input type="text" formControlName="email" (keypress)="validarEntrada.emit($event)" class="email_size" appClearOnAltD appLowercaseOnChange />
        </ng-template>
      </div>
    </div>

    <div class="flex gap-1" *ngIf="isVisibleEnderecoinstituicao">
      <div class="institution_data__nome">
        <label><strong i18n>{{ 'Rua' | translate}}:</strong></label>
        <ng-container *ngIf="isSmartCase; else instituicaoRuaInput">
        <input type="text" formControlName="rua" (keypress)="validarEntrada.emit($event)" class="address_size" [ngClass]="{'uppercase': !instituicaoForm.get('rua')?.dirty, 'lowercase': instituicaoForm.get('rua')?.dirty}" appClearOnAltD appSmartCase />
        </ng-container>
        <ng-template #instituicaoRuaInput>
          <input type="text" formControlName="rua" (keypress)="validarEntrada.emit($event)" class="address_size" appClearOnAltD appLowercaseOnChange />
        </ng-template>
      </div>
      
      <div class="institution_data__nome">
        <label><strong i18n>{{ 'Cidade' | translate}}:</strong></label>
        <ng-container *ngIf="isSmartCase; else instituicaoLocalidadeInput">
        <input type="text" formControlName="localidade" (keypress)="validarEntrada.emit($event)" class="local_size" [ngClass]="{'uppercase': !instituicaoForm.get('localidade')?.dirty, 'lowercase': instituicaoForm.get('localidade')?.dirty}" appClearOnAltD appSmartCase />
        </ng-container>
        <ng-template #instituicaoLocalidadeInput>
          <input type="text" formControlName="localidade" (keypress)="validarEntrada.emit($event)" class="local_size" appClearOnAltD appLowercaseOnChange />
        </ng-template>
      </div>
    </div>

    <div formArrayName="telefone" class="flex gap-1">
      <div *ngFor="let tel of telefoneArray.controls | slice:0:2; let j = index">
        <label><strong i18n>Telefone</strong> {{j + 1}}:</label>
        <ng-container *ngIf="isSmartCase; else instituicaoTelefoneInput">
          <input [formControl]="tel" (keypress)="validarEntrada.emit($event)" class="phone_size" [ngClass]="{'uppercase': !tel.dirty, 'lowercase': tel.dirty}" appClearOnAltD >
        </ng-container>
        <ng-template #instituicaoTelefoneInput>
          <input [formControl]="tel" (keypress)="validarEntrada.emit($event)" class="phone_size" appClearOnAltD appLowercaseOnChange />
        </ng-template>
        <button type="button" class="addRemoveButton" (click)="removeTelefone(j)" i18n *ngIf="j>=1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
        </button>
      </div>
      
      <div class="">
        <button type="button"  class="addRemoveButton buttonSpecial" (click)="addTelefone()" i18n>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
        </button>
      </div>
    </div>
  </div>
</div>